// Need to use inline styles so inner components can have styling set.
// See this reference comment: https://github.com/signavio/react-mentions/issues/226#issuecomment-366652081
// See default styles here: https://github.com/signavio/react-mentions/blob/master/demo/src/examples/defaultStyle.js

import { colorBlue50 } from "./Comments.module.scss";

const PADDING = "0.5rem";
const TEXT_AREA_MAX_HEIGHT = "10rem";

const mentionsInputInlineStyle = {
  minHeight: "3rem",
  maxHeight: TEXT_AREA_MAX_HEIGHT,
  wordBreak: "break-word",
  suggestions: {
    top: "88%",
    border: "1px solid lightgray",
    borderRadius: 5,
    maxHeight: "15rem",
    overflowY: "scroll",
    zIndex: 999
  },
  '&multiLine': {
    input: {
      border: "1px solid lightgray",
      padding: PADDING,
      borderRadius: 5,
      overflowY: "scroll"
    },
    highlighter: {
      padding: PADDING,
      color: colorBlue50,
      zIndex: 1,
      position: "relative",
      pointerEvents: "none",
      fontWeight: 400,
      maxHeight: TEXT_AREA_MAX_HEIGHT,
      overflowY: "scroll"
    }
  }
};

export default mentionsInputInlineStyle;
